/** general */
export const RESET_REDUX = "RESET_REDUX";
export const RESET_ON_IMPERSONATION = "RESET_ON_IMPERSONATION";

/** auth service */
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_LOGOUT_IN_PROGRESS = "SET_LOGOUT_IN_PROGRESS";

/** credit limit */
export const GET_CREDIT_LIMIT_START = "GET_CREDIT_LIMIT_START";
export const GET_CREDIT_LIMIT_SUCCESS = "GET_CREDIT_LIMIT_SUCCESS";
export const GET_CREDIT_LIMIT_FAILURE = "GET_CREDIT_LIMIT_FAILURE";

/** translations service */
export const GET_TRANSLATIONS_START = "GET_TRANSLATIONS_START";
export const GET_TRANSLATIONS_SUCCESS = "GET_TRANSLATIONS_SUCCESS";
export const GET_TRANSLATIONS_FAILURE = "GET_TRANSLATIONS_FAILURE";
export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";

/** customer data */
export const GET_CUSTOMER_DATA_START = "GET_CUSTOMER_DATA_START";
export const GET_CUSTOMER_DATA_SUCCESS = "GET_CUSTOMER_DATA_SUCCESS";
export const GET_CUSTOMER_DATA_FAILURE = "GET_CUSTOMER_DATA_FAILURE";

/** order types */
export const GET_ORDER_TYPES_START = "GET_ORDER_TYPES_START";
export const GET_ORDER_TYPES_SUCCESS = "GET_ORDER_TYPES_SUCCESS";
export const GET_ORDER_TYPES_FAILURE = "GET_ORDER_TYPES_FAILURE";

/** order history */
export const FETCH_ORDERS_BEGIN = "FETCH_ORDERS_BEGIN";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";
export const FETCH_ORDERS_SYNC = "FETCH_ORDERS_SYNC";

/* Order detail */
export const FETCH_ORDER_DETAILS_BEGIN = "FETCH_ORDER_DETAILS_BEGIN";
export const FETCH_ORDER_DETAILS_SUCCESS = "FETCH_ORDER_DETAILS_SUCCESS";
export const FETCH_ORDER_DETAILS_FAILURE = "FETCH_ORDER_DETAILS_FAILURE";
export const UPDATE_ORDER_DETAILS_STATE = "UPDATE_ORDER_DETAILS_STATE";

/* due payments */
export const FETCH_DUE_PAYMENTS_BEGIN = "FETCH_DUE_PAYMENTS_BEGIN";
export const FETCH_DUE_PAYMENTS_SUCCESS = "FETCH_DUE_PAYMENTS_SUCCESS";
export const FETCH_DUE_PAYMENTS_FAILURE = "FETCH_DUE_PAYMENTS_FAILURE";

/* tickets tracking */
export const FETCH_TICKETS_BEGIN = "FETCH_TICKETS_BEGIN";
export const FETCH_TICKETS_SUCCESS = "FETCH_TICKETS_SUCCESS";
export const FETCH_TICKETS_FAILURE = "FETCH_TICKETS_FAILURE";
